import React from 'react';

export default function ViewRepresentation(props: {
    element: any,
    viewProps?: any,
    layout?: any,
}) {
    const {
        element: Element,
        viewProps = {},
        layout,
    } = props;
    if (!layout && !('layout' in Element)) {
        return <Element {...viewProps}/>;
    }

    const Layout = layout ?? Element.layout;
    const breadcrumbs = 'breadcrumbs' in Element ? Element.breadcrumbs() : undefined;

    return <Layout breadcrumbs={breadcrumbs}><Element {...viewProps}/></Layout>;
}
